import React from 'react';
import OrderManagementSearchBox from './components/OrderManagementSearchBox';
import OrderManagementList from './components/OrderManagementList';
import useOrderManagement from './hooks/useOrderManagement';

const OrderManagement = (): JSX.Element => {
  const {
    totalCount,
    orderList,
    selectedCheckboxIds,
    setSelectedCheckboxIds,
    pagination,
    changePagination,
    changeSearchOption,
    cancelOrders,
    returnOrders,
    readyOrders,
    downloadTotalExcel,
    downloadSelectedExcel,
  } = useOrderManagement();

  return (
    <div>
      <OrderManagementSearchBox onSearch={changeSearchOption} />
      <OrderManagementList
        totalCount={totalCount}
        orderList={orderList}
        selectedCheckboxIds={selectedCheckboxIds}
        setSelectedCheckboxIds={setSelectedCheckboxIds}
        pagination={pagination}
        changePagination={changePagination}
        cancelOrders={cancelOrders}
        returnOrders={returnOrders}
        readyOrders={readyOrders}
        downloadTotalExcel={downloadTotalExcel}
        downloadSelectedExcel={downloadSelectedExcel}
      />
    </div>
  );
};
export default OrderManagement;
